import { render, staticRenderFns } from "./pickup-code.vue?vue&type=template&id=0e97a844&scoped=true"
import script from "./pickup-code.vue?vue&type=script&lang=ts"
export * from "./pickup-code.vue?vue&type=script&lang=ts"
import style0 from "./pickup-code.vue?vue&type=style&index=0&id=0e97a844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97a844",
  null
  
)

export default component.exports